import React from 'react';

import { withContainer } from 'core/cache';

import EditInitiative from '../components/editInitiative';

const EditInitiativeContainer = ({ initiative }) => (
  <EditInitiative isLoading={initiative.status !== 'success'} />
);

export default withContainer(EditInitiativeContainer, {
  // include topicSelection to trigger re-render
  cache: { initiative: { isListener: true }, topicSelection: { isListener: true } },
});
